import palette from 'lib/styles/palette';
import styled, { css } from 'styled-components';
import { CloseBtn } from 'lib/styles/icons';
import { useState, useRef, useEffect } from 'react';

const Modal = ({ children, closeModal, header, ...rest }) => {
  const onClick = e => {
    if (!closeModal) return;
    if (e.target.className.includes('outer')) {
      closeModal();
    }
  };

  const [isScrollbar, setIsScrollbar] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current?.scrollHeight - ref.current?.clientHeight > 0) {
      setIsScrollbar(true);
    }
  }, [ref.current?.scrollHeight]);

  return (
    <ModalBlock className="outer" onClick={onClick}>
      {header?.text && (
        <Header width={header.width} isScrollbar={isScrollbar}>
          <div className="title">{header.text}</div>
          <div className="icon">
            <CloseBtn onClick={closeModal} />
          </div>
        </Header>
      )}
      <Box header={header} ref={ref} {...rest}>
        {children}
      </Box>
    </ModalBlock>
  );
};

export default Modal;

const ModalBlock = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Box = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  background: #fff;
  box-shadow: 0 0 50px 0 rgba(0, 0, 0, 0.04);
  border-radius: 5px;
  margin: 0 10px;
  &::-webkit-scrollbar {
    width: 10px;
    background: ${palette.theme[0]};
    border-radius: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background: ${palette.theme[3]};
    border-radius: 10px;
  }

  ${props =>
    props.header &&
    css`
      border-top-left-radius: 0;
      border-top-right-radius: 0;
    `}
`;

const Header = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${props =>
    props.isScrollbar ? `${props.width + 10}px` : `${props.width}px`};
  border-radius: 5px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  background-color: #fff;
  padding: 15px 0;

  .title {
    font-weight: bold;
    font-size: 22px;
  }

  .icon {
    position: absolute;
    right: 20px;
    font-size: 20px;
    &:hover {
      color: ${palette.gray[6]};
    }
  }
`;
